import { render, staticRenderFns } from "./HorizontalFilter.vue?vue&type=template&id=534a2488&scoped=true&"
import script from "./HorizontalFilter.vue?vue&type=script&lang=js&"
export * from "./HorizontalFilter.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalFilter.vue?vue&type=style&index=0&id=534a2488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534a2488",
  null
  
)

export default component.exports